import { createSlice } from '@reduxjs/toolkit'

import { get, post, put, destroy } from 'state/thunks/machines'

const initialState = {
  response: {
    TotalCount: 0,
    Items: []
  },
  loading: false,
  success: false,
  error: null
}

const machinesSlice = createSlice({
  name: 'machines',
  initialState,
  reducers: {
    clear: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(get.pending, state => {
      state.loading = true
    })

    builder.addCase(get.fulfilled, (state, action) => {
      state.response = action.payload.response
      state.loading = false
      state.success = true
      state.error = null
    })

    builder.addCase(get.rejected, (state, action) => {
      state.loading = false
      state.success = false
      state.error = action.payload
    })

    builder.addCase(post.pending, state => {
      state.loading = true
    })

    builder.addCase(post.rejected, (state, action) => {
      state.loading = false
      state.success = false
      state.error = action.payload
    })

    builder.addCase(destroy.pending, state => {
      state.loading = true
    })

    builder.addCase(destroy.rejected, (state, action) => {
      state.loading = false
      state.success = false
      state.error = action.payload
    })

    builder.addCase(put.pending, state => {
      state.loading = true
    })

    builder.addCase(put.rejected, (state, action) => {
      state.loading = false
      state.success = false
      state.error = action.payload
    })
  }
})

export const actions = {
  ...machinesSlice.actions,
  get,
  post,
  put,
  destroy
}

export const reducer = machinesSlice.reducer
